import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [clicked1, setClicked1] = useState('px-2');
  const [clicked2, setClicked2] = useState('px-2');
  const [clicked3, setClicked3] = useState('px-2');

  const changeLanguage = (language, id) => {
    i18n.changeLanguage(language);
    if (id === 0) {
        setClicked1("text-red-300 px-2");
        setClicked2("px-2");
    }
    else if (id === 1) {
      setClicked1("px-2");
      setClicked2("text-red-300 px-2");
      setClicked3("px-2");
    }
    else{
        setClicked1("px-2");
        setClicked2("px-2");
        setClicked3("text-green-300 px-2");
    }
  };

  return (
    <div>
      <button class={clicked2} onClick={() => changeLanguage("it", 1)}>IT</button>
      <button class={clicked1} onClick={() => changeLanguage("en", 0)}>EN</button>
      <button class={clicked3} onClick={() => changeLanguage("de", 2)}>DE</button>
      {/* Add more buttons for other languages */}
    </div>
  );
}

export default LanguageSwitcher;
